var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 186,
    viewBox: "0 0 246 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 93,
    r: 76,
    fill: "#E4E1FF",
    stroke: "#1B1B1B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8985 126.642C48.3636 124.906 49.6603 122.721 51.4484 120.359C53.2184 118.02 55.3992 115.599 57.5311 113.402C59.6606 111.207 61.728 109.25 63.2638 107.841C63.8086 107.341 64.2861 106.91 64.6751 106.563C64.8384 107.058 65.0367 107.67 65.2586 108.375C65.8841 110.363 66.6959 113.092 67.4428 116.057C68.1905 119.026 68.8685 122.213 69.2321 125.124C69.5995 128.064 69.6297 130.605 69.1646 132.34C67.1901 139.71 60.7533 144.044 55.0422 142.514C49.3312 140.983 45.9239 134.011 47.8985 126.642Z",
    fill: "#FFBB00",
    stroke: "#1B1B1B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.286 127.843C198.821 126.107 197.524 123.922 195.736 121.559C193.966 119.221 191.785 116.799 189.653 114.602C187.524 112.408 185.456 110.451 183.921 109.041C183.376 108.542 182.898 108.111 182.509 107.764C182.346 108.259 182.148 108.871 181.926 109.576C181.3 111.564 180.489 114.293 179.742 117.258C178.994 120.227 178.316 123.414 177.952 126.324C177.585 129.264 177.555 131.805 178.02 133.541C179.994 140.91 186.431 145.244 192.142 143.714C197.853 142.184 201.261 135.212 199.286 127.843Z",
    fill: "#FFBB00",
    stroke: "#1B1B1B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94 129C109.192 68.1025 133.794 49.1938 160 129",
    stroke: "#1B1B1B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4104 60.8945C101.685 64.9348 107.906 69.2984 116.419 60.8945",
    stroke: "#1B1B1B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.025 60.8945C135.299 64.9348 141.521 69.2984 150.034 60.8945",
    stroke: "#1B1B1B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6383 159.779L9.79881 147.94C9.12239 147.263 8.02568 147.263 7.34926 147.94L6.941 148.348C6.26457 149.025 6.26457 150.121 6.941 150.798L18.7805 162.637C19.457 163.314 20.5537 163.314 21.2301 162.637L21.6383 162.229C22.3148 161.553 22.3148 160.456 21.6383 159.779Z",
    fill: "#FF5C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6362 150.797L9.79665 162.636C9.12023 163.313 8.02352 163.313 7.34709 162.636L6.93883 162.228C6.26241 161.552 6.26241 160.455 6.93883 159.779L18.7784 147.939C19.4548 147.263 20.5515 147.263 21.2279 147.939L21.6362 148.347C22.3126 149.024 22.3126 150.12 21.6362 150.797Z",
    fill: "#FF5C00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.638 40.5939L213.799 28.7543C213.122 28.0779 212.025 28.0779 211.349 28.7543L210.941 29.1626C210.264 29.839 210.264 30.9357 210.941 31.6121L222.78 43.4517C223.457 44.1281 224.553 44.1281 225.23 43.4517L225.638 43.0434C226.314 42.367 226.314 41.2703 225.638 40.5939Z",
    fill: "#FFBB00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.636 31.6113L213.796 43.4508C213.12 44.1272 212.023 44.1272 211.347 43.4508L210.938 43.0425C210.262 42.3661 210.262 41.2694 210.938 40.593L222.778 28.7534C223.454 28.077 224.551 28.077 225.228 28.7534L225.636 29.1617C226.312 29.8381 226.312 30.9348 225.636 31.6113Z",
    fill: "#FFBB00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultFailed);
export default __webpack_public_path__ + "static/media/result-failed.f7e27408.svg";
export { ForwardRef as ReactComponent };